<template>
    <div class="lottery">
        <div v-for="(item, index) in activityList" :key="index">
            <!-- 印花抽奖卡片 -->
            <div v-if="item.type === 1" class="lottery-card">
                <!-- 卡片头部 -->
                <div class="card-header">
                    <div class="header-left">
                        <div class="card-icon stamp">
                            <img class="icon-image" src="@/assets/user_icon.png" alt="图标" />
                        </div>
                        <div class="card-title-info">
                            <span class="card-title">{{ item.name }}</span>
                            <span class="card-desc">消费3个印花抽一次</span>
                        </div>
                    </div>
                    <div class="status-tag long-term">长期有效</div>
                </div>

                <!-- 印花信息 -->
                <div class="stamp-info">
                    <span class="stamp-text">当前拥有：<span class="stamp-number">{{ userStamps }}</span> 印花</span>
                </div>

                <!-- 抽奖规则 -->
                <div class="lottery-rules">
                    <div class="rules-title">
                        <span class="rules-label">抽奖规则</span>
                    </div>
                    <div class="rules-content">
                        <div class="rule-item">
                            <span class="rule-dot">•</span>
                            <span class="rule-text">参与门槛：3个印花可兑换1次线上抽奖机会</span>
                        </div>
                        <div class="rule-item">
                            <span class="rule-dot">•</span>
                            <span class="rule-text">抽奖奖池：50元京东购物卡、益力多产品1排（可选原味/青提/芒果）、印花1个等</span>
                        </div>
                        <div class="rule-item">
                            <span class="rule-dot">•</span>
                            <span class="rule-text">中奖说明：印花奖品直接发放至会员账号，实物奖品将生成【印花抽奖券】</span>
                        </div>
                    </div>
                    <div class="important-notice">
                        <div class="notice-title">
                            <span>重要说明</span>
                        </div>
                        <div class="notice-list">
                            <div class="notice-item">
                                <span class="notice-num">①</span>
                                <span class="notice-text">【印花抽奖券】需与益力多产品（至少1排）组合线上下单时使用。若产品订单发生取消的，印花抽奖券随之退回原账户。</span>
                            </div>
                            <div class="notice-item">
                                <span class="notice-num">②</span>
                                <span class="notice-text">【印花抽奖券】需在10天内使用，逾期自动失效，奖品不补发且印花不退回。</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 抽奖按钮 -->
                <div class="lottery-button blue" @click="onStampLottery(item.id)">
                    <span>立即抽奖</span>
                </div>
            </div>

            <!-- 购买达标抽奖卡片 -->
            <div v-if="item.type === 2" class="lottery-card">
                <!-- 卡片头部 -->
                <div class="card-header">
                    <div class="header-left">
                        <div class="card-icon purple">
                            <img class="icon-image" src="@/assets/shopping_trolley_icon.png" alt="图标" />
                        </div>
                        <div class="card-title-info">
                            <span class="card-title">{{ item.name }}</span>
                            <span class="card-desc">累计购买达标获机会</span>
                        </div>
                    </div>
                    <div class="status-tag limited">限时活动</div>
                </div>

                <!-- 购买天数 -->
                <div class="purchase-info">
                    <div class="purchase-item">
                        <span class="purchase-label">已使用抽奖次数</span>
                        <span class="purchase-value">已使用 {{ item.lotteryTicketNumber.usedLotteryTicketNumber }}/{{ item.lotteryTicketNumber.totalLotteryTicketNumber }} 次</span>
                    </div>
                    <div class="progress-container">
                        <div class="progress-bar">
                            <div class="progress-fill blue" :style="{ width: (item.lotteryTicketNumber.totalLotteryTicketNumber > 0 ? item.lotteryTicketNumber.usedLotteryTicketNumber / item.lotteryTicketNumber.totalLotteryTicketNumber * 100 : 0) + '%' }"></div>
                        </div>
                    </div>
                </div>

                <!-- 商品数量 -->
                <div class="purchase-info">
                    <div class="purchase-item">
                        <span class="purchase-label">已达标抽奖次数</span>
                        <span class="purchase-value">已达标 {{ item.lotteryTicketNumber.totalLotteryTicketNumber }}/7 次</span>
                    </div>
                    <div class="progress-container">
                        <div class="progress-bar">
                            <div class="progress-fill green" :style="{ width: (item.lotteryTicketNumber.totalLotteryTicketNumber / 7 * 100) + '%' }"></div>
                        </div>
                    </div>
                </div>

                <!-- 活动时间 -->
                <div class="activity-time">
                    <span>活动时间：{{ item.startTime }} - {{ item.endTime }}</span>
                </div>

                <!-- 去完成按钮 -->
                <div v-if="item.lotteryTicketNumber.usedLotteryTicketNumber === item.lotteryTicketNumber.totalLotteryTicketNumber" class="lottery-button purple" @click="onUse()">
                    <span>去完成</span>
                </div>

                <!-- 去使用按钮 -->
                <div v-else class="lottery-button purple" @click="onCheckInLottery(item.id)">
                    <span>去使用</span>
                </div>
            </div>
        </div>

        <div class="empty-tip" v-if="activityList.length === 0">
            <span>暂无活动</span>
        </div>
    </div>
</template>

<script>
import { lotteryStampShopActivityList } from '../../api/StampShop'
import axios from '../../utils/axios'
import { parseTime } from '../../unitls'

export default {
    name: 'Lottery',
    data() {
        return {
            activityList: [],
            userStamps: 0
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        async loadData() {
            try {
                // 获取抽奖活动列表
                const activityRes = await lotteryStampShopActivityList({})

                if (activityRes.code === this.$API_CODE.OK) {
                    this.activityList = activityRes.data.map(item => {
                        item.startTime = parseTime(item.startAt)
                        item.endTime = parseTime(item.endAt)
                        return item
                    })
                }

                // 获取用户印花数量
                const stampRes = await axios({
                    url: '/stamp',
                    method: 'get',
                    params: {}
                })

                if (stampRes.code === this.$API_CODE.OK) {
                    this.userStamps = stampRes.data.stampQuantity
                }
            } catch (error) {
                console.error('加载数据失败:', error)
            }
        },

        /**
         * 印花抽奖
         */
        onStampLottery(activityId) {
            this.$router.push({
                path: '/stampLottery',
                query: { activityId: activityId }
            })
        },

        /**
         * 打卡抽奖
         */
        onCheckInLottery(activityId) {
            this.$router.push({
                path: '/clockInLottery',
                query: { activityId: activityId }
            })
        },

        /**
         * 去使用按钮
         */
        onUse() {
            this.$router.push({
                path: '/placeOrder',
                query: { type: '0' }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.lottery {
    background-color: #f5f5f5;
    min-height: 100vh;
    padding: 0 10px 10px;
}

/* 抽奖卡片 */
.lottery-card {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px 15px;
    margin-top: 10px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
}

/* 卡片头部 */
.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
}

.header-left {
    display: flex;
    align-items: center;
    flex: 1;
}

.card-icon {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-icon.stamp {
    background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%);
}

.card-icon.purple {
    background: linear-gradient(135deg, #ce93d8 0%, #9c27b0 100%);
}

.icon-image {
    width: 24px;
    height: 24px;
    filter: brightness(0) invert(1);
}

.card-title-info {
    display: flex;
    flex-direction: column;
}

.card-title {
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 4px;
}

.card-desc {
    font-size: 12px;
    color: #999999;
}

.status-tag {
    padding: 4px 10px;
    border-radius: 16px;
    font-size: 11px;
    white-space: nowrap;
}

.status-tag.long-term {
    background-color: #e8f5e9;
    color: #4caf50;
}

.status-tag.limited {
    background-color: #ffebee;
    color: #f44336;
}

/* 印花信息 */
.stamp-info {
    background: linear-gradient(135deg, #fff8e1 0%, #fff3e0 100%);
    padding: 10px 12px;
    border-radius: 6px;
    margin-bottom: 6px;
    border-left: 3px solid #ff9800;
}

.stamp-text {
    font-size: 13px;
    color: #666666;
}

.stamp-number {
    color: #ff6b6b;
    font-size: 16px;
    font-weight: 600;
    margin: 0 4px;
}

/* 抽奖规则 */
.lottery-rules {
    text-align: left;
    background-color: #fafafa;
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 12px;
}

.rules-title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.rules-icon {
    font-size: 16px;
    margin-right: 6px;
}

.rules-label {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
}

.rules-content {
    margin-bottom: 10px;
}

.rule-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 14px;
    line-height: 1.6;
}

.rule-item:last-child {
    margin-bottom: 0;
}

.rule-dot {
    color: #ff6b6b;
    font-size: 12px;
    margin-right: 6px;
    flex-shrink: 0;
}

.rule-text {
    font-size: 12px;
    color: #666666;
    flex: 1;
}

/* 重要说明 */
.important-notice {
    background: linear-gradient(135deg, #fff5f5 0%, #ffebee 100%);
    border-radius: 4px;
    padding: 10px;
    border-left: 3px solid #ef5350;
}

.notice-title {
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: 600;
    color: #ef5350;
    margin-bottom: 8px;
}

.notice-icon {
    font-size: 14px;
    margin-right: 4px;
}

.notice-list {
    padding-left: 4px;
}

.notice-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 6px;
    line-height: 1.6;
}

.notice-item:last-child {
    margin-bottom: 0;
}

.notice-num {
    color: #ef5350;
    font-size: 12px;
    font-weight: 600;
    margin-right: 6px;
    flex-shrink: 0;
}

.notice-text {
    font-size: 12px;
    color: #666666;
    flex: 1;
}

/* 进度条 */
.progress-container {
    margin-bottom: 15px;
}

.progress-bar {
    height: 8px;
    background-color: #e0e0e0;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
}

.progress-fill {
    height: 100%;
    border-radius: 4px;
    transition: width 0.3s ease;
}

.progress-fill.green {
    background-color: #4caf50;
}

.progress-fill.blue {
    background-color: #2196f3;
}

/* 购买信息 */
.purchase-info {
    margin-bottom: 10px;
}

.purchase-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.purchase-label {
    font-size: 14px;
    color: #666666;
}

.purchase-value {
    font-size: 14px;
    color: #333333;
    font-weight: 500;
}

/* 活动时间 */
.activity-time {
    font-size: 12px;
    color: #999999;
    margin-bottom: 15px;
}

/* 抽奖按钮 */
.lottery-button {
    width: 100%;
    height: 44px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    transition: all 0.3s ease;
    cursor: pointer;

    &:active {
        opacity: 0.8;
        transform: scale(0.98);
    }
}

.lottery-button.blue {
    background: linear-gradient(135deg, #42a5f5 0%, #1976d2 100%);
}

.lottery-button.purple {
    background: linear-gradient(135deg, #ab47bc 0%, #7b1fa2 100%);
}

.empty-tip {
    text-align: center;
    padding: 50px 0;
    color: #999;
    font-size: 14px;
}
</style>
